var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuHamburguesa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#ff7d23"
  }, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,10H4A1,1,0,0,1,4,8H28a1,1,0,0,1,0,2Z",
    fill: "#ff7d23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,17H4a1,1,0,0,1,0-2H28a1,1,0,0,1,0,2Z",
    fill: "#ff7d23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,24H4a1,1,0,0,1,0-2H28a1,1,0,0,1,0,2Z",
    fill: "#ff7d23"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "frame"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 32,
    width: 32,
    fill: "#ff7d23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHamburguesa);
export default __webpack_public_path__ + "static/media/menuHamburguesa.cd4e89ba097b4f11082ac2767caa4106.svg";
export { ForwardRef as ReactComponent };